module.exports = __webpack_public_path__ + "img/icon-slot.a705f73.webp";